import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../config/theme/baseTheme";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";
import { addressStyles, deliveryProofSectionStyles, detailsContainer, geocodedAddressStyles, tabularSectionCratesStyles, tabularSectionItemContentStyles, tagStyles, timelineStyles, useSideModalCloseOpenStyles } from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    tabs: {
      paddingTop: "0px",
      paddingLeft: "0px",
      minHeight: "38px",
      "& .tabLabel": {
        fontSize: "14px",
        fontWeight: 700,
        color: COLORS.BLACK,
      },
      "& .disabledTab": {
        opacity: 0.3,
      },
    },
    tabValues: {
      padding: "8px 0px 0px 0px",
    },
    titleContainer: {
      "& .headingContainer": {
        flexDirection: "column",
        "& .titleHeading": {
          fontSize: 20,
          fontWeight: 700,
          lineHeight: "28px",
          "& .content": {
            fontWeight: 600,
          },
        },
        "& .titleContent": {
          fontSize: 12,
          fontWeight: 600,
          "&.link": {
            cursor: "pointer",
          },
        },
      },
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1.5),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
        },
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
        ...geocodedAddressStyles(theme),
      },
      ...detailsContainer(theme),
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      "& .driverDetails": {
        paddingBottom: theme.spacing(1),
      },
      ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1),
      },
      "& .tabularSection": {
        paddingBottom: theme.spacing(1),
        "&:last-child": {
          paddingBottom: 0,
        },
        "&.crates": {
          ...tabularSectionCratesStyles(theme),
        },
        "& .itemDiv": {
          padding: theme.spacing(0),
          "& .content": {
            ...tabularSectionItemContentStyles(theme),
          },
        },
      },
    },
    roundCheckbox: {
      "& .MuiCheckbox-root": {
        borderRadius: "50%",
      },
      "& .MuiIconButton-label": {
        borderRadius: "50%",
      },
    },
    mycontentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .detailsHeader": {
        padding: theme.spacing(2),
        borderRadius: "4px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 48px rgba(0, 0, 0, 0.08)",
        backdropFilter: "blur(24px)",
        "& .vehicleType": {
          display: "flex",
          alignItems: "center",
          fontSize: "12px",
          fontWeight: 700,
          marginRight: "8px",
          textTransform: "capitalize",
        },
      },
      "& .deliveryDetails": {
        marginTop: "8px",
        "& .delivery": {
          fontSize: "14px",
          fontWeight: 400,
        },
        "& .deliveryTimeDetails": {
          fontSize: "14px",
          fontWeight: 700,
          lineHeight: "16px",
          "&.time": {
            marginLeft: "6px",
          },
        },
        "& .location": {
          width: "16px",
          height: "16px",
          marginRight: "8px",
        },
      },
      "& .detailsContainer": {
        marginTop: "0px",
        display: "flex",
        alignItems: "center",
        paddingRight: "8px",
      },
      "& .assignedDriverComponent": {
        marginTop: "16px",

        lineHeight: "16px",
        "& .driverTitle": {
          fontWeight: 600,
          fontSize: "14px",
        },
        "& .driverHeading": {
          fontWeight: 700,
          fontSize: "14px",
          padding: "4px",
        },
      },
      "& .driverComponent": {
        marginTop: "8px",
        display: "flex",
        justifyContent: "space-between",
        height: "40px",
        background: "#FAFAFB",
        padding: "12px",
        "& .driverTitle": {
          fontSize: "14px",
          fontWeight: 700,
          lineHeight: "16px",
        },
        "& .refresh": {
          height: "24px",
          width: "24px",
        },
      },
      "& .driverListContainer": {
        paddingBottom: theme.spacing(1),
        marginTop: "16px",
        "& .itemContainer": {
          padding: theme.spacing(0, 2),
          "&.header": {
            color: COLORS.DOVE_GRAY,
            fontWeight: 600,
            height: "56px",
            background: "#e6e6e6",
          },
        },
        "& .list-container": {
          display: "flex",
          height: "50px",
          background: "#FFFFFF",
          boxShadow: "0px 4px 48px rgb(0 0 0 / 8%)",
          backdropFilter: "blur(24px)",
          marginTop: "8px",
          borderLeft: "6px solid #c4c4c4",
          "&.assignedList": {
            borderLeft: "6px solid #F5C45D",
          },
          "&.unassignedList": {
            borderLeft: "6px solid #3ABA71",
          },
          "&$selected": {
            border: "2px solid #319E60",
          },
        },
        "& .driverStatus": {
          background: "#FFFFFF",
          border: "1.5px solid #319E60",
          borderRadius: "4px",
          fontWeight: 600,
          fontSize: 12,
          color: "#319E60",
          maxWidth: "140px",
          height: "24px",
          padding: "4px",
          "&.INFO_BLUE": {
            borderColor: COLORS.INFO_BLUE,
            color: COLORS.INFO_BLUE,
          },
          "&.SEA_GREEN": {
            borderColor: COLORS.SEA_GREEN,
            color: COLORS.SEA_GREEN,
          },
          "&.OCEAN_GREEN": {
            borderColor: COLORS.OCEAN_GREEN,
            color: COLORS.OCEAN_GREEN,
          },
          "&.GOLDEN_BELL": {
            borderColor: COLORS.GOLDEN_BELL,
            color: COLORS.GOLDEN_BELL,
          },
          "&.GREY_SCALE": {
            borderColor: COLORS.GREY_SCALE,
            color: COLORS.GREY_SCALE,
          },
          "&.ASSIGNED_LIGHT_BLUE": {
            borderColor: COLORS.ASSIGNED_LIGHT_BLUE,
            color: COLORS.ASSIGNED_LIGHT_BLUE,
          },
          "&.AMARANTH": {
            borderColor: COLORS.AMARANTH,
            color: COLORS.AMARANTH,
          },
          "&.DELIVARY_ORANGE": {
            borderColor: COLORS.DELIVARY_ORANGE,
            color: COLORS.DELIVARY_ORANGE,
          },
          "&.STORE_BROWN": {
            borderColor: COLORS.STORE_BROWN,
            color: COLORS.STORE_BROWN,
          },
          "&.PALE_GRAY": {
            borderColor: COLORS.PALE_GRAY,
            color: COLORS.PALE_GRAY,
          },
        },
        "& .buttonsContainer": {
          marginTop: "8px",
          "& .userBtn": {
            "&.secondary": {
              marginRight: theme.spacing(2),
            },
            /* '&.primary': {
                          background: "#DD2326",

                        } */
          },
        },
        /* '& .itemContainer': {
                  padding: theme.spacing(0, 2),
                  '&.items': {
                    backgroundColor: COLORS.SECONDARY_MAIN,
                    padding: theme.spacing(2),
                  },
                  '& p': {
                    fontSize: 14,
                    lineHeight: "17px",
                    fontWeight: 600
                  },
                  '&.header p': {
                    color: COLORS.DOVE_GRAY,
                    fontWeight: 500,
                  },
                  '& .itemColumn': {
                    padding: theme.spacing(0),
                    '&.item1': {
                      "& p": {
                        fontWeight: 400,
                        textTransform: "capitalize"
                      },
                      '& .rejectedReason': {
                        fontSize: 10,
                        color: COLORS.ALIZARIN_CRIMSON
                      },
                      '& .viewOriginalLink': {
                        fontSize: 9,
                        color: COLORS.COPY,
                        cursor: "pointer",
                        paddingRight: 6
                      },
                      '& .originalName': {
                        fontSize: 14,
                        lineHeight: "17px",
                        fontWeight: 400,
                      }
                    },
                    '&.item2': {
                      '& p': {
                        textAlign: "center",
                        '& .green': {
                          color: COLORS.PERSIAN_GREEN
                        }
                      }
                    },
                    '&.item3': {
                      '& p': {
                        textAlign: "center"
                      }
                    }
                  }
                } */
      },
      "& .tagContainer": {
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
        },
      },
      "& .detailsContent": {
        flexDirection: "column",
        flexWrap: "nowrap",
        padding: theme.spacing(3, 0, 2, 0),
        "& .contentRow": {
          paddingBottom: theme.spacing(3),
          "& .contentRowContainer": {
            justifyContent: "space-between",
          },
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .contentColumn": {
            flex: "2 0 0",
            "&:last-child": {
              flex: "1.5 0 0",
            },
            "& p": {
              fontSize: 14,
              lineHeight: "17px",
            },
            "& .label": {
              paddingBottom: theme.spacing(1),
            },
            "& .content": {
              fontWeight: 600,
            },
          },
          "&.twoItems": {
            "& .contentColumn": {
              "&:last-child": {
                flex: "2.5 0 0",
              },
            },
          },
          "&.btnContainer": {
            "& .contentColumn": {
              flex: "1 0 auto",
              "& .resetPasswordBtn": {
                width: "100%",
              },
              "& .endSessionBtn": {
                width: "300px",
              },
            },
          },
        },
      },
      "& .hubItemsSection": {
        "& .content": {
          width: "100%",
          "& .itemsContainer": {
            flexWrap: "nowrap",
            "& .item": {
              padding: theme.spacing(2, 0),
              borderBottom: `1px solid ${theme.palette.secondary.dark}`,
              "&:first-child": {
                padding: 0,
                paddingBottom: theme.spacing(2),
              },
              "&:last-child": {
                borderBottom: "none",
              },
              "& .itemContainer": {
                justifyContent: "space-between",
                "& p": {
                  fontSize: 14,
                  lineHeight: "17px",
                  fontWeight: 600,
                },
                "&.header p": {
                  color: COLORS.DOVE_GRAY,
                  fontWeight: 500,
                },
              },
            },
          },
        },
      },
    },
    ...timelineStyles(theme),
    noData: {
      fontSize: "14px",
      padding: "24px",
      textAlign: "center",
    },
    selected: {
      background: "yellow",
    },
    searchTextbox: {
      display: "flex",
      justifyContent: "flex-end",
      "& .MuiOutlinedInput-root": {
        minWidth: 200,
      },
    },
    main: {
      display: "flex",
    },
    checkbox: {
      marginLeft: "0px",
    },
    legend: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "16px",
      color: COLORS.TEXT_PRIMARY,
      marginRight: theme.spacing(2),
    },
    assignedStatusIcon: {
      color: COLORS.GOLDEN_BELL,
      width: 10,
      height: 10,
      marginRight: theme.spacing(0.75),
      marginTop: "2px",
    },
    unassignedStatusIcon: {
      color: COLORS.OCEAN_GREEN,
      width: 10,
      height: 10,
      marginRight: theme.spacing(0.75),
      marginTop: "2px",
    },
    dialogPaperPropsRoot: {
      margin: 0,
      marginLeft: "auto",
      maxHeight: "none",
      height: "100vh",
      width: 680,
    },
    confirmDialogPaperPropsRoot: {
      width: 338,
      height: 214,
      margin: "auto",
      borderRadius: theme.spacing(1),
    },
    confirmDialogContentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .contentItem": {
        "& p": {
          lineHeight: 1.2,
        },
        "&.heading": {
          "& p": {
            fontSize: 24,
            fontWeight: 600,
          },
        },
        "&.desc": {
          padding: theme.spacing(0, 2.5),
          "& p": {
            fontSize: 18,
            fontWeight: 400,
            "& .count": {
              fontWeight: 600,
            },
          },
        },
      },
    },
    confirmDialogButtonsContainer: {
      justifyContent: "center",
      "& .dialogBtn": {
        "&.primary": {
          marginLeft: theme.spacing(1),
        },
      },
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    ...useSideModalCloseOpenStyles(),
    driverListContainer: {
      maxHeight: "150px",
      overflow: "scroll",
    },
    assignedSupportDriverContainer: {
      maxHeight: "240px",
      overflow: "scroll",
      marginBottom: "8px",
    },
    driverList: {
      maxHeight: "240px",
      overflow: "scroll",
    },
    infoIconStyle: {
      marginTop: "4px",
      marginLeft: "-16px",
      width: "14px",
    },
    assignedDriversContainer: {
      alignItems: "center",
      "& .driverTitle": {
        fontWeight: 400,
        fontSize: "14px",
      },
      "& .chipContainer": {
        display: "flex",
        flexWrap: "wrap", // Enable wrapping
        gap: "8px", // Add spacing between chips
        justifyContent: "flex-start",
      },
    },
    assignedDriverTitleContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between", // Adjust spacing between title and chips
      marginBottom: theme.spacing(2),
    },
    pilles: {
      gap: 12,
      margin: "8px 4px",
      fontWeight: 600,
      "& .MuiChip-root": {
        background: "#FFFFFF",
        border: "1px solid #DCDCDC",
        color: COLORS.BLACK,
        borderRadius: 48,
        height: 30,
        padding: 4,
      },
    },
    searchHeaderContainer: {
      marginTop: "8px",
    },
    legendContainer: {
      display: "flex",
      alignItems: "center",
    },
    assignedLegend: {
      paddingLeft: "6px",
    },
    vehicleSelectContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    // Vehicle Filter Styles
    vehicleFilterBadge: {
      "& .MuiBadge-badge": {
        top: 2,
        right: -4,
        minWidth: 16,
        height: 16,
        fontSize: 10,
        padding: "0 4px",
      },
    },
    vehicleFilterTrigger: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(1.25, 1.75),
      minWidth: 160,
      justifyContent: "space-between",
      backgroundColor: "#fff",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "#999",
      },
    },
    vehicleFilterText: {
      fontSize: 14,
      color: "#333",
    },
    vehicleFilterIcon: {
      width: 18,
      height: 18,
    },
    vehiclePopoverPaper: {
      marginTop: theme.spacing(1),
      borderRadius: theme.spacing(1),
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      minWidth: 220,
    },
    vehiclePopoverContent: {
      padding: theme.spacing(2),
    },
    selectAllLabel: {
      fontSize: 14,
      fontWeight: 500,
    },
    vehicleItemLabel: {
      fontSize: 14,
    },
    filterDivider: {
      borderTop: "1px solid #e0e0e0",
      paddingTop: theme.spacing(1.5),
      marginBottom: theme.spacing(0.5),
    },
    vehicleItemContainer: {
      display: "flex",
      marginLeft: 0,
      marginRight: 0,
    },
    vehicleItemBorder: {
      borderBottom: "1px solid #e0e0e0",
    },
    filterCheckbox: {
      marginRight: theme.spacing(1),
    },
    filterButtonsContainer: {
      marginTop: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
      borderTop: "1px solid #e0e0e0",
    },
    filterButton: {
      textTransform: "none",
      fontSize: 13,
      padding: theme.spacing(0.75, 1.5),
      borderRadius: theme.spacing(0.75),
      fontWeight: 500,
    },
    alignCenter:{
      textAlign: "center",
    },
    driverNameCell: {
      fontSize: "14px",
      fontWeight: 500,
      display: "flex",
      flexDirection: "column",
      wordWrap: "break-word",
      wordBreak: "break-all",
      maxWidth: "100%",
    },
    driverStatusCell: {
      textAlign: "center",
    },
    proximityCell: {
      textAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    waitTimeRow: {
      marginTop: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    clockIcon: {
      height: "12px",
      width: "12px",
      marginRight: "4px",
    },
    waitTimeText: {
      fontSize: "12px",
    },
    assignmentsCell: {
      textAlign: "right",
      fontSize: "14px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 4,
    },
    limitIcon: {
      fontSize: 14,
      color: COLORS.ALIZARIN_CRIMSON,
      cursor: "default",
    },
  })
);